import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from "react-redux";
import store from "./store/index"
import UsuarioHome from "./pages/ModuloInicio"
import LoginModulo from "./pages/LoginModulo";
import SeleccionServicio from "./pages/SeleccionServicio";
import PantallaTurnos from "./pages/PantallaTurnos";
import LoginAgentes from "./pages/LoginAgentes";
import HomeAgente from "./pages/HomeAgente";
import HomeAdmin from "./pages/HomeAdmin";
import HomeDirectivo from "./pages/HomeDirectivo";
import NotFound from "./pages/404NoEncontrado";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { UserAgentApplication } from "msal";
import { msalConfig } from "./authConfig";

export const msalApp = new UserAgentApplication(msalConfig);

ReactDOM.render(
    <Provider store={store}>
        <Router basename={"/digiturno"}>
            <Switch>
                <Route exact path="/" component={LoginModulo} />
                <Route exact path="/Usuario/Home" component={UsuarioHome} />
                <Route exact path="/Usuario/SeleccionarServicio" component={SeleccionServicio} />
                <Route exact path="/Pantalla/:handle" component={PantallaTurnos} />
                <Route exact path="/Cliente" component={LoginAgentes} />
                <Route exact path="/Cliente/Agente" component={HomeAgente} />
                <Route exact path="/Cliente/Admin" component={HomeAdmin} />
                <Route exact path="/Cliente/Directivo" component={HomeDirectivo} />
                <Route path="*" component={NotFound} />
            </Switch>
        </Router>
    </Provider>, document.getElementById('root')
);
// <Router>
// <Router basename={"/digiturno"}>

//Agregar en el 'package.json' la siguiente linea para TomCat: 
//"homepage": "https://serviciosweb.konradlorenz.edu.co/digiturno",
//"homepage": "https://serviciosweb.konradlorenz.edu.co/digiturno",
registerServiceWorker();
